import PageShell from "@/components/PageShell";

const Section = ({ title, children }) => (
  <div className="mb-8">
    {title && <h2 className="font-display text-xl md:text-2xl font-bold text-brand-ink mb-3">{title}</h2>}
    <div className="text-brand-slate/75 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <PageShell testid="privacy-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 md:py-24">
        <span className="text-brand-terracotta font-semibold tracking-[0.2em] uppercase text-sm">Documento legale</span>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold text-brand-ink mt-4 mb-3">Privacy Policy</h1>
        <p className="text-brand-slate/50 mb-12">Ultimo aggiornamento: 21 febbraio 2026</p>

        <Section>
          <p>La presente informativa descrive le modalità di gestione e trattamento dei dati personali degli utenti che consultano il sito web e che utilizzano i servizi di contatto e richiesta preventivo.</p>
        </Section>

        <Section title="1. Titolare del trattamento">
          <p>Il Titolare del trattamento dei dati personali è:</p>
          <p className="font-semibold text-brand-ink">Multiservice la Fenice S.R.L.s</p>
          <p>Partita IVA e Codice Fiscale: 11151291215<br />
          Numero REA: NA-1158476<br />
          Indirizzo: Via A. Carrelli, 50 - 80126 Napoli (NA), Italia<br />
          Email PEC: multiservicelafenice@pec.it</p>
          <p>Il Titolare è responsabile del trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR).</p>
        </Section>

        <Section title="2. Tipologia di dati raccolti">
          <p>Il sito può raccogliere le seguenti categorie di dati personali:</p>
          <p><strong>Dati identificativi e di contatto</strong> forniti volontariamente dall'utente: nome e cognome, indirizzo email, numero di telefono, eventuali informazioni inserite nel messaggio di richiesta preventivo.</p>
          <p><strong>Dati tecnici</strong> raccolti automaticamente durante la navigazione: indirizzo IP, tipo di browser, sistema operativo, informazioni di navigazione. Questi dati vengono raccolti esclusivamente per finalità tecniche e di sicurezza.</p>
        </Section>

        <Section title="3. Finalità del trattamento">
          <ul className="list-disc pl-5 space-y-1">
            <li>rispondere alle richieste di contatto</li>
            <li>fornire preventivi e informazioni sui servizi offerti</li>
            <li>gestire le comunicazioni con l'utente</li>
            <li>adempiere ad obblighi legali o normativi</li>
            <li>garantire la sicurezza del sito</li>
          </ul>
          <p>I dati non verranno utilizzati per finalità diverse senza il consenso esplicito dell'utente.</p>
        </Section>

        <Section title="4. Base giuridica del trattamento">
          <ul className="list-disc pl-5 space-y-1">
            <li>consenso espresso dall'utente (art. 6 par. 1 lett. a GDPR)</li>
            <li>esecuzione di misure precontrattuali richieste dall'utente (art. 6 par. 1 lett. b GDPR)</li>
            <li>adempimento di obblighi legali (art. 6 par. 1 lett. c GDPR)</li>
            <li>legittimo interesse del titolare alla gestione e sicurezza del sito (art. 6 par. 1 lett. f GDPR)</li>
          </ul>
        </Section>

        <Section title="5. Modalità del trattamento">
          <p>Il trattamento dei dati avviene mediante strumenti informatici e telematici, con modalità organizzative e logiche strettamente correlate alle finalità indicate. Il Titolare adotta misure tecniche e organizzative adeguate per garantire la sicurezza, l'integrità e la riservatezza dei dati personali.</p>
        </Section>

        <Section title="6. Conservazione dei dati">
          <p>I dati personali saranno conservati per il tempo strettamente necessario a soddisfare le finalità per cui sono stati raccolti e comunque non oltre:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>12 mesi per le richieste di contatto e preventivo</li>
            <li>periodi più lunghi se richiesto da obblighi di legge</li>
          </ul>
          <p>Al termine del periodo di conservazione, i dati saranno cancellati o anonimizzati.</p>
        </Section>

        <Section title="7. Comunicazione dei dati">
          <p>I dati personali non saranno venduti né ceduti a terzi. Potranno essere comunicati esclusivamente a fornitori di servizi tecnici necessari al funzionamento del sito e ad autorità competenti, ove richiesto dalla legge.</p>
        </Section>

        <Section title="8. Trasferimento dei dati fuori dall'Unione Europea">
          <p>Il sito è ospitato su piattaforme che potrebbero trasferire dati fuori dall'Unione Europea. In tali casi, il trasferimento avviene nel rispetto delle garanzie previste dal GDPR.</p>
        </Section>

        <Section title="9. Diritti dell'utente">
          <p>Ai sensi degli articoli 15–22 del GDPR, l'utente ha il diritto di accedere ai propri dati, richiederne la rettifica o la cancellazione, limitare od opporsi al trattamento, richiedere la portabilità dei dati e revocare il consenso in qualsiasi momento.</p>
          <p>Per esercitare tali diritti, l'utente può contattare il Titolare all'indirizzo: <a href="mailto:multiservicelafenice@pec.it" className="text-brand-goldDark font-semibold">multiservicelafenice@pec.it</a></p>
        </Section>

        <Section title="10. Cookie">
          <p>Il sito utilizza cookie tecnici e, eventualmente, cookie di terze parti necessari al funzionamento del sito e al miglioramento dell'esperienza di navigazione. Per maggiori informazioni, consultare la Cookie Policy.</p>
        </Section>

        <Section title="11. Modifiche alla presente informativa">
          <p>Il Titolare si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con data di aggiornamento.</p>
        </Section>
      </div>
    </PageShell>
  );
}
